export default {
  name: 'saleTitle',
  data() {
    return {
      currentType: 'day',
      timeOption: [{
        label: '今日',
        key: 'day'
      }, {
        label: '本周',
        key: 'week'
      }, {
        label: '本月',
        key: 'month'
      }, {
        label: '本年',
        key: 'year'
      }, {
        label: '时间段',
        key: 'range'
      }]
    };
  },
  created() {},
  mounted() {},
  methods: {
    changeType(type) {
      if (type === this.currentType) {
        return;
      }
      this.currentType = type;
      if (type == 'range') return;
      this.sendValue();
    },
    changeTime(data, dataString) {
      console.log(dataString);
    },
    sendValue() {
      this.$emit('sendCurrent', this.currentType, this.currentTime);
    }
  }
};